import { Rect } from '../../../platform/geom/Rect';
import { TextAlignment, TextSettings } from '../../canvas/entities/TextConventions';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { Token } from './Token';

const baseTokenValueTextSettings = TextSettings.from({
    fontColor: '#333',
    fontFamily: 'Rubik',
    fontSize: 18,
    maxFontSize: null,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 1.25,
    textAlignH: TextAlignment.middle,
    textAlignV: TextAlignment.middle,
    textMargin: 10,
});

const valueLayout = (object: Token, area: Rect) => {

    const fontColor = object.background;

    const fontSize = Math.min(
        baseTokenValueTextSettings.maxFontSize,
        (TextRuler.fit(object.value, baseTokenValueTextSettings, area.width, area.height)),
    );

    return {
        bounds: area,
        settings: { ...baseTokenValueTextSettings, fontColor, fontSize },
    };
};

export const TokenLayout = (sticky: Token) => {

    const base = new Rect(0, 0, sticky.width, sticky.height);
    const value = valueLayout(sticky, base);

    return Object.freeze({ base, value });
};

export type TokenLayout = ReturnType<typeof TokenLayout>;
